import React from 'react';
import { KeyboardArrowDown } from '@material-ui/icons';

import './css/ScrollToTheBottomButton.css';
import './css/ScrollToTheBottomButton.mobile.css';
import '../../../../../../../css/utils/flex.css';


const ScrollToTheBottomButton = ({
  readAllTheWayToTheBottom,
  unreadMessages,
  inputAreaHeight,
}) => {
  let buttonClassName = 'scroll-to-bottom';
  if (unreadMessages > 0) {
    buttonClassName += ' scroll-to-bottom--with-new-messages';
  }

  return (
    <button
      className={buttonClassName}
      style={{ bottom: `${inputAreaHeight}px` }}
      onClick={readAllTheWayToTheBottom}
    >
      <div className="scroll-to-bottom-container">
        <div className="flex items-center justify-center">
          <div>
            <KeyboardArrowDown fontSize="large" />
          </div>
          <div>
            Scroll to end
          </div>
        </div>
        <div className="unread-count">
          {unreadMessages > 0 && (
            `${unreadMessages} new`
          )}
        </div>
      </div>
    </button>
  );
};

export default ScrollToTheBottomButton;
